module.exports = __webpack_public_path__ + "static/img/n2n.2345578.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/n2n.png
// module id = 389
// module chunks = 1